import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { VisibleOnly } from "@/components/utils/VisibleOnly";
import { StreamateCamera } from "@/components/ads/StreamateCamera";
import "./StreamateCameraModule.scss";

interface IStreamateCameraModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const StreamateCameraModule = ({ moduleId, moduleType }: IStreamateCameraModule) => {
  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <VisibleOnly className="GifPreview StreamateCameraDispatcher">
        <StreamateCamera />
      </VisibleOnly>
    </FeedModuleContainer>
  );
};
